import { getEnvVariable } from "./iniUtility"


const LOCAL_ENV_NAME = "devt04"
const LOCAL_USE_LOCAL_GRAPHQL = false

// Set by /config.js, which the .NET host builds from its environment variables.
// Empty when running locally, because nothing serves that file.
const runtime = window.__ASC_CONFIG__ || {}

// The Azure AD scope is always api://<the host we are served on>/<id>/user_impersonation.
const scopeFor = (host, id) => `api://${host}/${id}/user_impersonation`

// GraphQL sits on the same domain. In the first DNS label, keep the environment
// prefix if there is one and make the last part "graph":
//   devt09-teams.asc-recording.dev -> devt09-graph.asc-recording.dev
//   stage-teams.asc-recording.app  -> stage-graph.asc-recording.app
//   teams.asc-recording.app        -> graph.asc-recording.app
const graphqlUrlFor = (host) => {
    const [label, ...domain] = host.split(".")
    const graphLabel = [...label.split("-").slice(0, -1), "graph"].join("-")

    return `https://${graphLabel}.${domain.join(".")}/graphql`
}

// Deployed: everything follows from the application id plus the hostname we are
// served on, so a new environment needs no code change.
const deployedConfig = (id) => {
    const host = window.location.hostname

    return {
        id,
        qurl: runtime.graphqlUrl || graphqlUrlFor(host),
        impersonation: runtime.apiImpersonation || scopeFor(host, id)
    }
}

// Local: picked by name from the list in iniUtility.
const localConfig = () => {
    console.log("No runtime config found, using the local environment list")
    const env = getEnvVariable(LOCAL_ENV_NAME, LOCAL_USE_LOCAL_GRAPHQL)
    return {
        id: env.id,
        // Built from the list entry, since the browser hostname here is localhost.
        impersonation: scopeFor(`${env.name}-teams.asc-recording.${env.tld}`, env.id),
        qurl: env.qurl
    }
}

const config = runtime.applicationId ? deployedConfig(runtime.applicationId) : localConfig()

export const iniApplicationId = config.id
export const iniGraphqlUrl = config.qurl
export const iniApiImpersonation = config.impersonation

// Not environment dependent.
export const iniGraphMicrosoft = "https://graph.microsoft.com"
